import React, { useEffect, useState } from "react";
import { Button, Container, Accordion, Row, Col } from "react-bootstrap";
import { Images } from "./Images";
import { Link } from "react-router-dom";
import Faq from "../Screens/Faq";
// import { Route, Routes, Link } from "react-router-dom";

const FrequentlyAskQus = ({ cmsLits, faqLits }) => {
  // const [cardContent, setCardContent] = useState(
  //   [
  //   {
  //     question: "1. What is a flash loan arbitrage bot?",
  //     answer:
  //       "A flash loan arbitrage bot is an automated trading program that utilizes flash loans to exploit price differences between cryptocurrency exchanges. It leverages temporary liquidity provided by flash loans to execute profitable trades within a single transaction.",
  //   },
  //   {
  //     question: "2. How does the flash loan arbitrage bot work?",
  //     answer:
  //       "Lorem ipsum dolor sit amet consectetur. Elit euismod ipsum tristique donec et. Tincidunt ultricies fringilla orci eu tortor in ornare. Venenatis leo imperdiet quisque varius. Pretium lorem eget vitae lobortis luctus ridiculus.",
  //   },
  //   {
  //     question: "3. What are flash loans?",
  //     answer:
  //       "Lorem ipsum dolor sit amet consectetur. Elit euismod ipsum tristique donec et. Tincidunt ultricies fringilla orci eu tortor in ornare. Venenatis leo imperdiet quisque varius. Pretium lorem eget vitae lobortis luctus ridiculus.",
  //   },
  //   {
  //     question: "4. Is flash loan arbitrage trading risky?.",
  //     answer:
  //       "Lorem ipsum dolor sit amet consectetur. Elit euismod ipsum tristique donec et. Tincidunt ultricies fringilla orci eu tortor in ornare. Venenatis leo imperdiet quisque varius. Pretium lorem eget vitae lobortis luctus ridiculus.",
  //   },
  //   {
  //     question:
  //       "5. What are the potential benefits of using a flash loan arbitrage bot?",
  //     answer:
  //       "Lorem ipsum dolor sit amet consectetur. Elit euismod ipsum tristique donec et. Tincidunt ultricies fringilla orci eu tortor in ornare. Venenatis leo imperdiet quisque varius. Pretium lorem eget vitae lobortis luctus ridiculus.",
  //   },
  // ]
  // );

  const [cardContent, setCardContent] = useState();

  const [value1, setvalue1] = useState();
  const [value2, setvalue2] = useState();
  const [value3, setvalue3] = useState();

  useEffect(() => {
    if (faqLits) {
      setCardContent(faqLits);
    }
  }, [faqLits]);

  useEffect(() => {
    if (cmsLits) {
      setvalue1(cmsLits.find((value) => (value.identifier == 'Community1')))
      setvalue2(cmsLits.find((value) => (value.identifier == 'Community2')))
      setvalue3(cmsLits.find((value) => (value.identifier == 'Community3')))

    }
  }, [cmsLits]);


  return (
    <div className="frequently_askQus">
      <Container className="custom_container">
        <div className="header_sec">
          {/* <div className="d-flex align-items-center justify-content-center">
            <Button className="faq_Btn cmn_gradientBtn">
              <span>FAQ</span>
            </Button>
          </div> */}
          <Row>
            <Col xs={12} md={12} lg={10}>
              <p className="title-txt mb-0">
                Frequently Asked Questions
                {/* Frequently Asked <span className="linear-txt">Questions</span> */}
              </p>
            </Col>
          </Row>
        </div>
        <div className="row">
          <div className="col-12 col-sm-12 col-lg-5 col-xl-4 mb-4 mb-lg-0">
            <div className="meet_community">
              <div className="meet_communityinner">
                <p className="title-txt mb-0">Meet the World Community</p>
                {/* <p className="title-txt mb-0">Community.</p> */}

                <div className="chat_sec">
                  <div className="item">
                    <div className="icon">
                      <img src={Images.discord} className="src img-fluid" />
                    </div>
                    <div className="name">
                      <span className="val">Discord Chat</span>
                      <a href={value1?.content} target="_blank">
                        <img src={Images.topRightArrow} className="arrow_src" />

                      </a>
                    </div>
                  </div>
                  <div className="item">
                    <div className="icon">
                      <img src={Images.tele} className="src img-fluid" />
                    </div>
                    <div className="name">
                      <span className="val">Telegram Chat</span>



                      <a href={value2?.content} target="_blank">
                        <img src={Images.topRightArrow} className="arrow_src" />

                      </a>

                    </div>
                  </div>
                  <div className="item">
                    <div className="icon">
                      <img src={Images.twit} className="src img-fluid" />
                    </div>
                    <div className="name">
                      <span className="val">Twitter Chat</span>


                      <a href={value3?.content} target="_blank">
                        <img src={Images.topRightArrow} className="arrow_src" />

                      </a>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-12 col-lg-7 col-xl-8">
            <div className="qus_ans">
              <div className="qus_ansinner">
                <p className="title-txt mb-0">Frequently Asked Question</p>
                <div className="card_sec ">
                  <Accordion
                    defaultActiveKey={0}
                    className="freqQus_accordion"
                    flush
                  >
                    {cardContent &&
                      cardContent?.map((item, i) => {
                        if (i < 5) {
                          return (
                            <Accordion.Item eventKey={i} className="">
                              <Accordion.Header>{i + 1}. {item?.question}</Accordion.Header>
                              <Accordion.Body>{item?.answer}</Accordion.Body>
                            </Accordion.Item>
                          );
                        }
                      })}
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>



        {cardContent && cardContent.length > 5 ?
          <div className="loadMoreBtn_Sec">
            <Link to="/faq">
              <Button className="loadMore_btn cmn_blueBtn">Load more FAQ</Button>
            </Link>
          </div> : ""}




      </Container>
    </div>
  );
};

export default FrequentlyAskQus;
